import { Fragment } from 'react'

import { Link } from '@tanstack/react-router'
import { Logger } from 'commons/utils/logger'
import { DropDown } from 'ui/components'
import { TableButton } from 'ui/components/Buttons'

import { TableActionsItem, TableActionsProps } from './TableActionsProps'
import { DeleteItem, DetailsItem, EditItem, HistoryItem, Item } from './components'
import { getName, sortItems } from './utils'

import * as SC from './styles'

export const TableActions = (props: TableActionsProps) => {
  const { items, dataQaAttribute } = props

  if (!items.length) {
    Logger.getInstance().warning('"TableActions" component needs at least one menu item.')
    return null
  }

  const { uniqueItems, baseItems } = sortItems(items)

  const renderItem = (item: TableActionsItem, index: number) => (
    <Fragment key={index}>
      {item.type === 'delete' && <DeleteItem url={item.url} onClick={item.onClick} />}
      {item.type === 'edit' && <EditItem url={item.url} onClick={item.onClick} />}
      {item.type === 'details' && <DetailsItem url={item.url} onClick={item.onClick} />}
      {item.type === 'history' && <HistoryItem url={item.url} onClick={item.onClick} />}
      {item.type === 'option' && <Item key={index} title={item.title} onClick={item.onClick} url={item.url} />}
    </Fragment>
  )

  if (items.length > 1) {
    return (
      <DropDown menuPosition={'bottom-end'} dotsButtonQaAttribute={dataQaAttribute || 'Table-menu-dots-button'}>
        {uniqueItems.map((item, index) => renderItem(item, index))}
        {baseItems.length > 0 && (
          <>
            {uniqueItems.length > 0 && <SC.Divider />}
            <SC.BaseItemWrapper>{baseItems.map((item, index) => renderItem(item, index))}</SC.BaseItemWrapper>
          </>
        )}
      </DropDown>
    )
  }

  const title = uniqueItems.length ? getName(uniqueItems[0]) : getName(baseItems[0])
  const url = uniqueItems.length ? uniqueItems[0].url : baseItems[0].url
  const onClick = uniqueItems.length ? uniqueItems[0].onClick : baseItems[0].onClick

  return (
    <Link
      to={url}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault()
          onClick()
        }
      }}
    >
      <TableButton face={'neutral'}>{title}</TableButton>
    </Link>
  )
}
